<template>
    <button type="button"
        class="py-3 px-12 text-center font-normal text-sm tracking-relaxed cursor-pointer select-none uppercase transition-colors rounded-full"
        :class="reverse ? 'text-black bg-white hover:bg-blue-600 hover:text-white' : 'text-white bg-blue-600 hover:bg-blue-500'"
        @click="scrollTo"
    >
        <slot />
    </button>
</template>

<script>
import { scrollIntoView } from 'scroll-js';

export default {
    props: {
        section: {},
        reverse: { default: false },
    },

    methods: {
        scrollTo() {
            scrollIntoView(document.getElementById(this.section), document.body, {
                behavior: 'smooth',
            }).then(() => {
                // done scrolling document's body to show myElement
            });
        },
    },
}
</script>
